/** THIS FILE IS GENERATED, DO NOT MODIFY */
import { PluginObject, VueConstructor } from 'vue';
import RsAvatar from '@/components/_global/RsAvatar.vue';
import RsBadge from '@/components/_global/RsBadge.vue';
import RsBanner from '@/components/_global/RsBanner.vue';
import RsButton from '@/components/_global/RsButton.vue';
import RsButtonGroup from '@/components/_global/RsButtonGroup.vue';
import RsButtonList from '@/components/_global/RsButtonList.vue';
import RsButtonMenu from '@/components/_global/RsButtonMenu.vue';
import RsCalendar from '@/components/_global/RsCalendar.vue';
import RsCalendarEventModal from '@/components/_global/RsCalendarEventModal.vue';
import RsCard from '@/components/_global/RsCard.vue';
import RsCardBody from '@/components/_global/RsCardBody.vue';
import RsCheckboxGroup from '@/components/_global/RsCheckboxGroup.vue';
import RsChip from '@/components/_global/RsChip.vue';
import RsClear from '@/components/_global/RsClear.vue';
import RsCollapse from '@/components/_global/RsCollapse.vue';
import RsCollapseLite from '@/components/_global/RsCollapseLite.vue';
import RsCollapseTranslations from '@/components/_global/RsCollapseTranslations.vue';
import RsContactInfo from '@/components/_global/RsContactInfo.vue';
import RsContentBlock from '@/components/_global/RsContentBlock.vue';
import RsDataTableCellEditable from '@/components/_global/RsDataTableCellEditable.vue';
import RsDataTableTemp from '@/components/_global/RsDataTableTemp.vue';
import RsDataTableV2 from '@/components/_global/RsDataTableV2.vue';
import RsDateRange from '@/components/_global/RsDateRange.vue';
import RsDaysSelection from '@/components/_global/RsDaysSelection.vue';
import RsDraggable from '@/components/_global/RsDraggable.vue';
import RsDragger from '@/components/_global/RsDragger.vue';
import RsDragndrop from '@/components/_global/RsDragndrop.vue';
import RsDropDownScroll from '@/components/_global/RsDropDownScroll.vue';
import RsDropdown from '@/components/_global/RsDropdown.vue';
import RsDropdownActionMenu from '@/components/_global/RsDropdownActionMenu.vue';
import RsDropdownCheckboxes from '@/components/_global/RsDropdownCheckboxes.vue';
import RsDropdownItem from '@/components/_global/RsDropdownItem.vue';
import RsDynamicSortButton from '@/components/_global/RsDynamicSortButton.vue';
import RsFavorite from '@/components/_global/RsFavorite.vue';
import RsFilterBar from '@/components/_global/RsFilterBar.vue';
import RsFilterCat from '@/components/_global/RsFilterCat.vue';
import RsFormAudio from '@/components/_global/RsFormAudio.vue';
import RsFormCalendarCustom from '@/components/_global/RsFormCalendarCustom.vue';
import RsFormCheckButton from '@/components/_global/RsFormCheckButton.vue';
import RsFormCheckbox from '@/components/_global/RsFormCheckbox.vue';
import RsFormCheckbox3State from '@/components/_global/RsFormCheckbox3State.vue';
import RsFormCheckboxSearch from '@/components/_global/RsFormCheckboxSearch.vue';
import RsFormColorPicker from '@/components/_global/RsFormColorPicker.vue';
import RsFormDateRangePicker from '@/components/_global/RsFormDateRangePicker.vue';
import RsFormExternalInput from '@/components/_global/RsFormExternalInput.vue';
import RsFormFile from '@/components/_global/RsFormFile.vue';
import RsFormGroupedButtonSelect from '@/components/_global/RsFormGroupedButtonSelect.vue';
import RsFormImporterField from '@/components/_global/RsFormImporterField.vue';
import RsFormInput from '@/components/_global/RsFormInput.vue';
import RsFormNotEditable from '@/components/_global/RsFormNotEditable.vue';
import RsFormRadio from '@/components/_global/RsFormRadio.vue';
import RsFormRateInput from '@/components/_global/RsFormRateInput.vue';
import RsFormSearchBox from '@/components/_global/RsFormSearchBox.vue';
import RsFormSelect from '@/components/_global/RsFormSelect.vue';
import RsFormSettingsSelectOptions from '@/components/_global/RsFormSettingsSelectOptions.vue';
import RsFormSpinButton from '@/components/_global/RsFormSpinButton.vue';
import RsFormStrengthInput from '@/components/_global/RsFormStrengthInput.vue';
import RsFormSwitch from '@/components/_global/RsFormSwitch.vue';
import RsFormTags from '@/components/_global/RsFormTags.vue';
import RsFormTagsInput from '@/components/_global/RsFormTagsInput.vue';
import RsFormTagsInputV2 from '@/components/_global/RsFormTagsInputV2.vue';
import RsFormTagsSelector from '@/components/_global/RsFormTagsSelector.vue';
import RsFormTextarea from '@/components/_global/RsFormTextarea.vue';
import RsFormTipTap from '@/components/_global/RsFormTipTap.vue';
import RsGalleryItem from '@/components/_global/RsGalleryItem.vue';
import RsGalleryItemUpdated from '@/components/_global/RsGalleryItemUpdated.vue';
import RsGmaps from '@/components/_global/RsGmaps.vue';
import RsIFrameSpin from '@/components/_global/RsIFrameSpin.vue';
import RsIcon from '@/components/_global/RsIcon.vue';
import RsIconDisplay from '@/components/_global/RsIconDisplay.vue';
import RsIframe from '@/components/_global/RsIframe.vue';
import RsImage from '@/components/_global/RsImage.vue';
import RsImageHeader from '@/components/_global/RsImageHeader.vue';
import RsImageReplacer from '@/components/_global/RsImageReplacer.vue';
import RsImageUploader from '@/components/_global/RsImageUploader.vue';
import RsImporterFieldBanner from '@/components/_global/RsImporterFieldBanner.vue';
import RsImporterFieldIcon from '@/components/_global/RsImporterFieldIcon.vue';
import RsInfoBlock from '@/components/_global/RsInfoBlock.vue';
import RsInfoBlockSecondary from '@/components/_global/RsInfoBlockSecondary.vue';
import RsInlineForm from '@/components/_global/RsInlineForm.vue';
import RsInlineFormGroup from '@/components/_global/RsInlineFormGroup.vue';
import RsInlineFormToolbar from '@/components/_global/RsInlineFormToolbar.vue';
import RsLanguageSelect from '@/components/_global/RsLanguageSelect.vue';
import RsListGroup from '@/components/_global/RsListGroup.vue';
import RsListGroupItem from '@/components/_global/RsListGroupItem.vue';
import RsListingScoreHeart from '@/components/_global/RsListingScoreHeart.vue';
import RsModal from '@/components/_global/RsModal.vue';
import RsModalCheckboxes from '@/components/_global/RsModalCheckboxes.vue';
import RsModalDataTable from '@/components/_global/RsModalDataTable.vue';
import RsMultipleInputs from '@/components/_global/RsMultipleInputs.vue';
import RsNavigationButton from '@/components/_global/RsNavigationButton.vue';
import RsNoData from '@/components/_global/RsNoData.vue';
import RsOffCanvas from '@/components/_global/RsOffCanvas.vue';
import RsPageRedirect from '@/components/_global/RsPageRedirect.vue';
import RsPageTitle from '@/components/_global/RsPageTitle.vue';
import RsPagination from '@/components/_global/RsPagination.vue';
import RsPaginationBar from '@/components/_global/RsPaginationBar.vue';
import RsPhoneInput from '@/components/_global/RsPhoneInput.vue';
import RsPill from '@/components/_global/RsPill.vue';
import RsPolicies from '@/components/_global/RsPolicies.vue';
import RsPopout from '@/components/_global/RsPopout.vue';
import RsPropertyLocation from '@/components/_global/RsPropertyLocation.vue';
import RsPropertyTitle from '@/components/_global/RsPropertyTitle.vue';
import RsPropertyType from '@/components/_global/RsPropertyType.vue';
import RsRadioGroup from '@/components/_global/RsRadioGroup.vue';
import RsSearch from '@/components/_global/RsSearch.vue';
import RsSeoCard from '@/components/_global/RsSeoCard.vue';
import RsSettingsCard from '@/components/_global/RsSettingsCard.vue';
import RsSettingsRow from '@/components/_global/RsSettingsRow.vue';
import RsSettingsRowWide from '@/components/_global/RsSettingsRowWide.vue';
import RsSidebar from '@/components/_global/RsSidebar.vue';
import RsSidebarCardInbox from '@/components/_global/RsSidebarCardInbox.vue';
import RsSidebarCardList from '@/components/_global/RsSidebarCardList.vue';
import RsSidebarCardProperty from '@/components/_global/RsSidebarCardProperty.vue';
import RsSidebarListGroupItem from '@/components/_global/RsSidebarListGroupItem.vue';
import RsSpin from '@/components/_global/RsSpin.vue';
import RsSpinButton from '@/components/_global/RsSpinButton.vue';
import RsStarRating from '@/components/_global/RsStarRating.vue';
import RsStatus from '@/components/_global/RsStatus.vue';
import RsStatusBadge from '@/components/_global/RsStatusBadge.vue';
import RsTab from '@/components/_global/RsTab.vue';
import RsTableTranslations from '@/components/_global/RsTableTranslations.vue';
import RsTabs2 from '@/components/_global/RsTabs2.vue';
import RsTag from '@/components/_global/RsTag.vue';
import RsTextIcon from '@/components/_global/RsTextIcon.vue';
import RsThreeStateRadio from '@/components/_global/RsThreeStateRadio.vue';
import RsThumbnail from '@/components/_global/RsThumbnail.vue';
import RsTimeInterval from '@/components/_global/RsTimeInterval.vue';
import RsTimeSlotSelector from '@/components/_global/RsTimeSlotSelector.vue';
import RsTitleIcon from '@/components/_global/RsTitleIcon.vue';
import RsToastUndo from '@/components/_global/RsToastUndo.vue';
import RsToggleTranslation from '@/components/_global/RsToggleTranslation.vue';
import RsTooltip from '@/components/_global/RsTooltip.vue';
import RsTranslationBadge from '@/components/_global/RsTranslationBadge.vue';
import RsTranslationMessage from '@/components/_global/RsTranslationMessage.vue';
import RsUserpilotHelp from '@/components/_global/RsUserpilotHelp.vue';

export interface IGlobalComponents {
  RsAvatar: typeof RsAvatar;
  RsBadge: typeof RsBadge;
  RsBanner: typeof RsBanner;
  RsButton: typeof RsButton;
  RsButtonGroup: typeof RsButtonGroup;
  RsButtonList: typeof RsButtonList;
  RsButtonMenu: typeof RsButtonMenu;
  RsCalendar: typeof RsCalendar;
  RsCalendarEventModal: typeof RsCalendarEventModal;
  RsCard: typeof RsCard;
  RsCardBody: typeof RsCardBody;
  RsCheckboxGroup: typeof RsCheckboxGroup;
  RsChip: typeof RsChip;
  RsClear: typeof RsClear;
  RsCollapse: typeof RsCollapse;
  RsCollapseLite: typeof RsCollapseLite;
  RsCollapseTranslations: typeof RsCollapseTranslations;
  RsContactInfo: typeof RsContactInfo;
  RsContentBlock: typeof RsContentBlock;
  RsDataTableCellEditable: typeof RsDataTableCellEditable;
  RsDataTableTemp: typeof RsDataTableTemp;
  RsDataTableV2: typeof RsDataTableV2;
  RsDateRange: typeof RsDateRange;
  RsDaysSelection: typeof RsDaysSelection;
  RsDraggable: typeof RsDraggable;
  RsDragger: typeof RsDragger;
  RsDragndrop: typeof RsDragndrop;
  RsDropDownScroll: typeof RsDropDownScroll;
  RsDropdown: typeof RsDropdown;
  RsDropdownActionMenu: typeof RsDropdownActionMenu;
  RsDropdownCheckboxes: typeof RsDropdownCheckboxes;
  RsDropdownItem: typeof RsDropdownItem;
  RsDynamicSortButton: typeof RsDynamicSortButton;
  RsFavorite: typeof RsFavorite;
  RsFilterBar: typeof RsFilterBar;
  RsFilterCat: typeof RsFilterCat;
  RsFormAudio: typeof RsFormAudio;
  RsFormCalendarCustom: typeof RsFormCalendarCustom;
  RsFormCheckButton: typeof RsFormCheckButton;
  RsFormCheckbox3State: typeof RsFormCheckbox3State;
  RsFormCheckbox: typeof RsFormCheckbox;
  RsFormCheckboxSearch: typeof RsFormCheckboxSearch;
  RsFormColorPicker: typeof RsFormColorPicker;
  RsFormDateRangePicker: typeof RsFormDateRangePicker;
  RsFormExternalInput: typeof RsFormExternalInput;
  RsFormFile: typeof RsFormFile;
  RsFormGroupedButtonSelect: typeof RsFormGroupedButtonSelect;
  RsFormImporterField: typeof RsFormImporterField;
  RsFormInput: typeof RsFormInput;
  RsFormNotEditable: typeof RsFormNotEditable;
  RsFormRadio: typeof RsFormRadio;
  RsFormRateInput: typeof RsFormRateInput;
  RsFormSearchBox: typeof RsFormSearchBox;
  RsFormSelect: typeof RsFormSelect;
  RsFormSettingsSelectOptions: typeof RsFormSettingsSelectOptions;
  RsFormSpinButton: typeof RsFormSpinButton;
  RsFormStrengthInput: typeof RsFormStrengthInput;
  RsFormSwitch: typeof RsFormSwitch;
  RsFormTags: typeof RsFormTags;
  RsFormTagsInput: typeof RsFormTagsInput;
  RsFormTagsInputV2: typeof RsFormTagsInputV2;
  RsFormTagsSelector: typeof RsFormTagsSelector;
  RsFormTextarea: typeof RsFormTextarea;
  RsFormTipTap: typeof RsFormTipTap;
  RsGalleryItem: typeof RsGalleryItem;
  RsGalleryItemUpdated: typeof RsGalleryItemUpdated;
  RsGmaps: typeof RsGmaps;
  RsIFrameSpin: typeof RsIFrameSpin;
  RsIcon: typeof RsIcon;
  RsIconDisplay: typeof RsIconDisplay;
  RsIframe: typeof RsIframe;
  RsImage: typeof RsImage;
  RsImageHeader: typeof RsImageHeader;
  RsImageReplacer: typeof RsImageReplacer;
  RsImageUploader: typeof RsImageUploader;
  RsImporterFieldBanner: typeof RsImporterFieldBanner;
  RsImporterFieldIcon: typeof RsImporterFieldIcon;
  RsInfoBlock: typeof RsInfoBlock;
  RsInfoBlockSecondary: typeof RsInfoBlockSecondary;
  RsInlineForm: typeof RsInlineForm;
  RsInlineFormGroup: typeof RsInlineFormGroup;
  RsInlineFormToolbar: typeof RsInlineFormToolbar;
  RsLanguageSelect: typeof RsLanguageSelect;
  RsListGroup: typeof RsListGroup;
  RsListGroupItem: typeof RsListGroupItem;
  RsListingScoreHeart: typeof RsListingScoreHeart;
  RsModal: typeof RsModal;
  RsModalCheckboxes: typeof RsModalCheckboxes;
  RsModalDataTable: typeof RsModalDataTable;
  RsMultipleInputs: typeof RsMultipleInputs;
  RsNavigationButton: typeof RsNavigationButton;
  RsNoData: typeof RsNoData;
  RsOffCanvas: typeof RsOffCanvas;
  RsPageRedirect: typeof RsPageRedirect;
  RsPageTitle: typeof RsPageTitle;
  RsPagination: typeof RsPagination;
  RsPaginationBar: typeof RsPaginationBar;
  RsPhoneInput: typeof RsPhoneInput;
  RsPill: typeof RsPill;
  RsPolicies: typeof RsPolicies;
  RsPopout: typeof RsPopout;
  RsPropertyLocation: typeof RsPropertyLocation;
  RsPropertyTitle: typeof RsPropertyTitle;
  RsPropertyType: typeof RsPropertyType;
  RsRadioGroup: typeof RsRadioGroup;
  RsSearch: typeof RsSearch;
  RsSeoCard: typeof RsSeoCard;
  RsSettingsCard: typeof RsSettingsCard;
  RsSettingsRow: typeof RsSettingsRow;
  RsSettingsRowWide: typeof RsSettingsRowWide;
  RsSidebar: typeof RsSidebar;
  RsSidebarCardInbox: typeof RsSidebarCardInbox;
  RsSidebarCardList: typeof RsSidebarCardList;
  RsSidebarCardProperty: typeof RsSidebarCardProperty;
  RsSidebarListGroupItem: typeof RsSidebarListGroupItem;
  RsSpin: typeof RsSpin;
  RsSpinButton: typeof RsSpinButton;
  RsStarRating: typeof RsStarRating;
  RsStatus: typeof RsStatus;
  RsStatusBadge: typeof RsStatusBadge;
  RsTab: typeof RsTab;
  RsTableTranslations: typeof RsTableTranslations;
  RsTabs2: typeof RsTabs2;
  RsTag: typeof RsTag;
  RsTextIcon: typeof RsTextIcon;
  RsThreeStateRadio: typeof RsThreeStateRadio;
  RsThumbnail: typeof RsThumbnail;
  RsTimeInterval: typeof RsTimeInterval;
  RsTimeSlotSelector: typeof RsTimeSlotSelector;
  RsTitleIcon: typeof RsTitleIcon;
  RsToastUndo: typeof RsToastUndo;
  RsToggleTranslation: typeof RsToggleTranslation;
  RsTooltip: typeof RsTooltip;
  RsTranslationBadge: typeof RsTranslationBadge;
  RsTranslationMessage: typeof RsTranslationMessage;
  RsUserpilotHelp: typeof RsUserpilotHelp;
}

export const GlobalComponentPlugin: PluginObject<null> = {
  install(app: VueConstructor) {
    app.component('RsAvatar', RsAvatar);
    app.component('RsBadge', RsBadge);
    app.component('RsBanner', RsBanner);
    app.component('RsButton', RsButton);
    app.component('RsButtonGroup', RsButtonGroup);
    app.component('RsButtonList', RsButtonList);
    app.component('RsButtonMenu', RsButtonMenu);
    app.component('RsCalendar', RsCalendar);
    app.component('RsCalendarEventModal', RsCalendarEventModal);
    app.component('RsCard', RsCard);
    app.component('RsCardBody', RsCardBody);
    app.component('RsCheckboxGroup', RsCheckboxGroup);
    app.component('RsChip', RsChip);
    app.component('RsClear', RsClear);
    app.component('RsCollapse', RsCollapse);
    app.component('RsCollapseLite', RsCollapseLite);
    app.component('RsCollapseTranslations', RsCollapseTranslations);
    app.component('RsContactInfo', RsContactInfo);
    app.component('RsContentBlock', RsContentBlock);
    app.component('RsDataTableCellEditable', RsDataTableCellEditable);
    app.component('RsDataTableTemp', RsDataTableTemp);
    app.component('RsDataTableV2', RsDataTableV2);
    app.component('RsDateRange', RsDateRange);
    app.component('RsDaysSelection', RsDaysSelection);
    app.component('RsDraggable', RsDraggable);
    app.component('RsDragger', RsDragger);
    app.component('RsDragndrop', RsDragndrop);
    app.component('RsDropDownScroll', RsDropDownScroll);
    app.component('RsDropdown', RsDropdown);
    app.component('RsDropdownActionMenu', RsDropdownActionMenu);
    app.component('RsDropdownCheckboxes', RsDropdownCheckboxes);
    app.component('RsDropdownItem', RsDropdownItem);
    app.component('RsDynamicSortButton', RsDynamicSortButton);
    app.component('RsFavorite', RsFavorite);
    app.component('RsFilterBar', RsFilterBar);
    app.component('RsFilterCat', RsFilterCat);
    app.component('RsFormAudio', RsFormAudio);
    app.component('RsFormCalendarCustom', RsFormCalendarCustom);
    app.component('RsFormCheckButton', RsFormCheckButton);
    app.component('RsFormCheckbox', RsFormCheckbox);
    app.component('RsFormCheckbox3State', RsFormCheckbox3State);
    app.component('RsFormCheckboxSearch', RsFormCheckboxSearch);
    app.component('RsFormColorPicker', RsFormColorPicker);
    app.component('RsFormDateRangePicker', RsFormDateRangePicker);
    app.component('RsFormExternalInput', RsFormExternalInput);
    app.component('RsFormFile', RsFormFile);
    app.component('RsFormGroupedButtonSelect', RsFormGroupedButtonSelect);
    app.component('RsFormImporterField', RsFormImporterField);
    app.component('RsFormInput', RsFormInput);
    app.component('RsFormNotEditable', RsFormNotEditable);
    app.component('RsFormRadio', RsFormRadio);
    app.component('RsFormRateInput', RsFormRateInput);
    app.component('RsFormSearchBox', RsFormSearchBox);
    app.component('RsFormSelect', RsFormSelect);
    app.component('RsFormSettingsSelectOptions', RsFormSettingsSelectOptions);
    app.component('RsFormSpinButton', RsFormSpinButton);
    app.component('RsFormStrengthInput', RsFormStrengthInput);
    app.component('RsFormSwitch', RsFormSwitch);
    app.component('RsFormTags', RsFormTags);
    app.component('RsFormTagsInput', RsFormTagsInput);
    app.component('RsFormTagsInputV2', RsFormTagsInputV2);
    app.component('RsFormTagsSelector', RsFormTagsSelector);
    app.component('RsFormTextarea', RsFormTextarea);
    app.component('RsFormTipTap', RsFormTipTap);
    app.component('RsGalleryItem', RsGalleryItem);
    app.component('RsGalleryItemUpdated', RsGalleryItemUpdated);
    app.component('RsGmaps', RsGmaps);
    app.component('RsIFrameSpin', RsIFrameSpin);
    app.component('RsIcon', RsIcon);
    app.component('RsIconDisplay', RsIconDisplay);
    app.component('RsIframe', RsIframe);
    app.component('RsImage', RsImage);
    app.component('RsImageHeader', RsImageHeader);
    app.component('RsImageReplacer', RsImageReplacer);
    app.component('RsImageUploader', RsImageUploader);
    app.component('RsImporterFieldBanner', RsImporterFieldBanner);
    app.component('RsImporterFieldIcon', RsImporterFieldIcon);
    app.component('RsInfoBlock', RsInfoBlock);
    app.component('RsInfoBlockSecondary', RsInfoBlockSecondary);
    app.component('RsInlineForm', RsInlineForm);
    app.component('RsInlineFormGroup', RsInlineFormGroup);
    app.component('RsInlineFormToolbar', RsInlineFormToolbar);
    app.component('RsLanguageSelect', RsLanguageSelect);
    app.component('RsListGroup', RsListGroup);
    app.component('RsListGroupItem', RsListGroupItem);
    app.component('RsListingScoreHeart', RsListingScoreHeart);
    app.component('RsModal', RsModal);
    app.component('RsModalCheckboxes', RsModalCheckboxes);
    app.component('RsModalDataTable', RsModalDataTable);
    app.component('RsMultipleInputs', RsMultipleInputs);
    app.component('RsNavigationButton', RsNavigationButton);
    app.component('RsNoData', RsNoData);
    app.component('RsOffCanvas', RsOffCanvas);
    app.component('RsPageRedirect', RsPageRedirect);
    app.component('RsPageTitle', RsPageTitle);
    app.component('RsPagination', RsPagination);
    app.component('RsPaginationBar', RsPaginationBar);
    app.component('RsPhoneInput', RsPhoneInput);
    app.component('RsPill', RsPill);
    app.component('RsPolicies', RsPolicies);
    app.component('RsPopout', RsPopout);
    app.component('RsPropertyLocation', RsPropertyLocation);
    app.component('RsPropertyTitle', RsPropertyTitle);
    app.component('RsPropertyType', RsPropertyType);
    app.component('RsRadioGroup', RsRadioGroup);
    app.component('RsSearch', RsSearch);
    app.component('RsSeoCard', RsSeoCard);
    app.component('RsSettingsCard', RsSettingsCard);
    app.component('RsSettingsRow', RsSettingsRow);
    app.component('RsSettingsRowWide', RsSettingsRowWide);
    app.component('RsSidebar', RsSidebar);
    app.component('RsSidebarCardInbox', RsSidebarCardInbox);
    app.component('RsSidebarCardList', RsSidebarCardList);
    app.component('RsSidebarCardProperty', RsSidebarCardProperty);
    app.component('RsSidebarListGroupItem', RsSidebarListGroupItem);
    app.component('RsSpin', RsSpin);
    app.component('RsSpinButton', RsSpinButton);
    app.component('RsStarRating', RsStarRating);
    app.component('RsStatus', RsStatus);
    app.component('RsStatusBadge', RsStatusBadge);
    app.component('RsTab', RsTab);
    app.component('RsTableTranslations', RsTableTranslations);
    app.component('RsTabs2', RsTabs2);
    app.component('RsTag', RsTag);
    app.component('RsTextIcon', RsTextIcon);
    app.component('RsThreeStateRadio', RsThreeStateRadio);
    app.component('RsThumbnail', RsThumbnail);
    app.component('RsTimeInterval', RsTimeInterval);
    app.component('RsTimeSlotSelector', RsTimeSlotSelector);
    app.component('RsTitleIcon', RsTitleIcon);
    app.component('RsToastUndo', RsToastUndo);
    app.component('RsToggleTranslation', RsToggleTranslation);
    app.component('RsTooltip', RsTooltip);
    app.component('RsTranslationBadge', RsTranslationBadge);
    app.component('RsTranslationMessage', RsTranslationMessage);
    app.component('RsUserpilotHelp', RsUserpilotHelp);
  },
};
